import { render } from "./SectionWeb.vue?vue&type=template&id=00e16aaa"
import script from "./SectionWeb.vue?vue&type=script&lang=js"
export * from "./SectionWeb.vue?vue&type=script&lang=js"

import exportComponent from "/home/webdevs/livesite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__